import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class UpdateCustomerOnboardingStateErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [{
                'code': 'cannot_advance_customer_onboarding_with_mandatory_fields_uncompleted',
                'text': 'cannot advance customer onboarding with mandatory fields uncompleted',
            }]
        }
    }

    static errorCodes() {
        return ['cannot_advance_customer_onboarding_with_mandatory_fields_uncompleted'];
    }
}